import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withRouter } from "react-router-dom";

import { DROPDOWN_DISPLAY_VALUE } from "config/constants";
import { SIGNIN, REGISTER1 } from "constants/authDrawer";

import NewNavigationDropdownItem from "./NewNavigationDropdownItem";
import NoStyleButton from "components/Library/NoStyleButton";
import DropdownWrapper from "../DropdownWrapper";
import SocialLinks from "../SocialLinks";
import Icon from "components/Library/Icon";
import SearchWindow from "./SearchWindow";

import styles from "./NewNavigation.css";
import LatestStories from "./LatestStories";

export class NewNavigationDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: true,
      collapse:
        props.isOpen || props.isLatestOpen
          ? DROPDOWN_DISPLAY_VALUE.SHOWN
          : DROPDOWN_DISPLAY_VALUE.HIDDEN,
    };
    this.closeButtonElement = React.createRef();
    this.lastMenuItemElement = React.createRef();
    this.lastLatestStoriesItemElement = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("keydown", this.focusLoop);
  }

  focusLoop = e => {
    //If forward navigating tab past final Item, shift focus to closeButton.
    if (
      e.target.className.indexOf("searchSubmit") !== -1 ||
      e.target.className.indexOf("finalLatestStoriesItem") !== -1
    ) {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        if (this.closeButtonElement) {
          this.closeButtonElement.current.focus();
        }
      }
    }

    //If backward navigating from closeButton, shift focus to last dropdown item.
    if (e.target.parentElement.className.indexOf("mobileExitSpan") !== -1) {
      if (e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        if (this.props.isOpen && this.lastMenuItemElement) {
          this.lastMenuItemElement.current.focus();
        } else if (
          this.props.isLatestOpen &&
          this.lastLatestStoriesItemElement
        ) {
          this.lastLatestStoriesItemElement.current.focus();
        }
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    const this2 = this;
    if (
      (nextProps.isOpen || nextProps.isLatestOpen) &&
      this.state.collapse === DROPDOWN_DISPLAY_VALUE.HIDDEN
    ) {
      //will open
      this.setState({ collapse: DROPDOWN_DISPLAY_VALUE.SHOWN }, () => {
        this2.closeButtonElement.current.focus();
      });
    } else if (
      !(nextProps.isOpen || nextProps.isLatestOpen) &&
      this.state.collapse === DROPDOWN_DISPLAY_VALUE.SHOWN
    ) {
      //will hide
      this.setState({ collapse: DROPDOWN_DISPLAY_VALUE.HIDDEN });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.transitionTag);
    window.removeEventListener("keydown", this.focusLoop);
  }

  getNewsletterItems() {
    return [
      {
        name: "Sign up for Axios AM",
        url: "https://link.axios.com/join/am-signup?utm_source=site_navbar",
      },
      { name: "All newsletters", url: "/newsletters", internal: true },
    ];
  }

  getMoreItems() {
    return [
      { name: "About", url: "/about", internal: true },
      { name: "Events", url: "/events", internal: true },
      { name: "Contact newsroom", url: "mailto:news@axios.com" },
      { name: "Privacy & terms", url: "/legal", internal: true },
      { name: "Advertise with us", url: "mailto:ads@axios.com" },
    ];
  }

  getAccountItems() {
    if (this.props.isLoggedIn) {
      return [
        {
          name: "Saved stories",
          url: "/users/saved-stories",
          internal: true,
          className: "gtm-saved-stories",
        },
        {
          name: "Your account",
          url: "/users/settings",
          internal: true,
          className: "gtm-your-account",
        },
        {
          name: "Log out",
          onClick: () =>
            this.props.authDrawerActions
              .logOut()
              .then(() => this.props.history.push("/")),
          className: "gtm-log-out",
        },
      ];
    }
    return [
      {
        name: "Sign in",
        onClick: () => this.props.openAuthDrawer(SIGNIN),
        className: "gtm-sign-in",
      },
      {
        name: "Create account",
        onClick: () => this.props.openAuthDrawer(REGISTER1),
        className: "gtm-create-account",
      },
    ];
  }

  render() {
    return (
      <DropdownWrapper
        collapse={this.state.collapse}
        isOpen={this.props.isOpen}
        isLatestOpen={this.props.isLatestOpen}
      >
        <span className={styles.mobileExitSpan}>
          <NoStyleButton
            onClick={this.props.toggle ? this.props.toggle : () => {}}
            buttonRef={this.closeButtonElement}
            ariaLabel="Exit mobile navigation menu"
          >
            <Icon name="close-nav" className={classNames(styles.exitIcon)} />
          </NoStyleButton>
        </span>
        {this.props.isOpen && (
          <>
            <NewNavigationDropdownItem
              name="Newsletters"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.getNewsletterItems()}
              className="gtm-menu-dropdown"
            />
            <NewNavigationDropdownItem
              name="Sections"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.props.results.sections}
              className="gtm-menu-dropdown"
            />
            <NewNavigationDropdownItem
              name="Special Features"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.props.results.specialFeatures || []}
              className="gtm-menu-dropdown"
            />
            <NewNavigationDropdownItem
              name="More"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.getMoreItems()}
              className="gtm-menu-dropdown"
            />

            <SocialLinks className={styles.socialList} />

            <NewNavigationDropdownItem
              name="Account"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.getAccountItems()}
              className={classNames("gtm-menu-dropdown")}
            />
            <span className={styles.mobileSearchSpan}>
              <SearchWindow searchRef={this.lastMenuItemElement} />
            </span>
          </>
        )}
        {this.props.isLatestOpen && (
          <div role="complementary">
            <LatestStories
              latestStoriesRef={this.lastLatestStoriesItemElement}
            />
          </div>
        )}
      </DropdownWrapper>
    );
  }
}

NewNavigationDropdown.proptypes = {
  isOpen: PropTypes.bool.isRequired,
  isLatestOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  results: PropTypes.array,
  isLoggedIn: PropTypes.bool,
  authDrawerActions: PropTypes.func,
  openAuthDrawer: PropTypes.func,
};

export default withRouter(NewNavigationDropdown);
